import { createBaseApi } from "../baseApi";
import PayloadModel from "model/_payload/payload.schema";
import { AffiliateProductsModel } from "model/products/affiliate.schema";
import { NomaroiProductsModel } from "model/products/nomaroi.schema";

export const productsApi = createBaseApi("product", "/products").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Categories
    getCategories: builder.query({
      query: () => {
        return {
          url: "categories",
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),

    // Brands
    getBrands: builder.query({
      query: () => {
        return {
          url: "brands",
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),

    // Affiliate Products
    getAffiliateProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "",
          method: "GET",
          params: { ...payload, is_active: true },
        };
      },
      providesTags: ["ActiveProducts"],
      transformResponse: (response) => {
        return AffiliateProductsModel.jsonToModel(response);
      },
    }),

    // Export Affiliate Products
    exportAffiliateProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "exports/active",
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // Nomaroi Products
    getNomaroiProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "",
          method: "GET",
          params: { ...payload, is_active: false },
        };
      },
      providesTags: ["UnactiveProducts"],
      transformResponse: (response) => {
        return NomaroiProductsModel.jsonToModel(response);
      },
    }),

    // Export Nomaroi Products
    exportNomaroiProducts: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "exports/inactive",
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // Add Product to Affiliate
    addProduct: builder.mutation({
      query: (value) => {
        const products = Array.isArray(value) ? value : [value];
        return {
          url: "active",
          method: "PATCH",
          body: { ids: products.map((item) => item.id), is_active: true },
        };
      },
      invalidatesTags: ["ActiveProducts", "UnactiveProducts"],
      transformResponse: (response) => {
        return response;
      },
    }),

    // Delete Product from Affiliate
    deleteProduct: builder.mutation({
      query: (value) => {
        const products = Array.isArray(value) ? value : [value];
        return {
          url: "active",
          method: "PATCH",
          body: { ids: products.map((item) => item.id), is_active: false },
        };
      },
      invalidatesTags: ["ActiveProducts", "UnactiveProducts"],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  //
  useGetCategoriesQuery,
  useGetBrandsQuery,
  useGetAffiliateProductsQuery,
  useGetNomaroiProductsQuery,
  useLazyExportAffiliateProductsQuery,
  useLazyExportNomaroiProductsQuery,
  useAddProductMutation,
  useDeleteProductMutation,
} = productsApi;
